import { adapter, useGetNotificationsQuery } from "./api"

export const useGetNotifications = () =>
  useGetNotificationsQuery(undefined, {
    selectFromResult: ({
      data: notifications,
      isLoading,
      isUninitialized,
    }) => ({
      notifications: notifications
        ? adapter.getSelectors().selectAll(notifications)
        : undefined,
      isLoading: isLoading || isUninitialized,
    }),
  })
